export enum ExternalUserRegistrationActions {
  CLAIM_ERROR = '[ExternalUserRegistrationActions] CLAIM_ERROR',
  CLAIM_REQUEST = '[ExternalUserRegistrationActions] CLAIM_REQUEST',
  CLAIM_SUCCESS = '[ExternalUserRegistrationActions] CLAIM_SUCCESS',
  CREATE_ERROR = '[ExternalUserRegistrationActions] CREATE_ERROR',
  CREATE_REQUEST = '[ExternalUserRegistrationActions] CREATE_REQUEST',
  CREATE_SUCCESS = '[ExternalUserRegistrationActions] CREATE_SUCCESS',
  UPDATE_LIST_ERROR = '[ExternalUserRegistrationActions] UPDATE_LIST_ERROR',
  UPDATE_LIST_REQUEST = '[ExternalUserRegistrationActions] UPDATE_LIST_REQUEST',
  UPDATE_LIST_SUCCESS = '[ExternalUserRegistrationActions] UPDATE_LIST_SUCCESS',
}
